import getElementPosition from './getElementPosition';
/**
 * @function scrolling to x,y or element with animation
 * @param {*} x offset x or HTMLElement
 * @param {*} y offset y
 * @param {*} i counter to stop scrolling, when i = 12, the scroll will not do animation and snap to destination
 */
const scrollingTo = (x, y, i = 0) => {
  if (x instanceof HTMLElement) {
    [x,y] = getElementPosition(x);
    console.log(x,y);
  }
  const xDiff = window.scrollX - x;
  const yDiff = window.scrollY - y;
  const scrollXScalar = Math.abs(xDiff) / 5;
  const scrollYScalar = Math.abs(yDiff) / 5;
  if ((scrollXScalar > 0.2 || scrollYScalar > 0.2) && i < 12) {
    window.scrollTo(window.scrollX - Math.sign(xDiff) * Math.ceil(scrollXScalar), window.scrollY - Math.sign(yDiff) * Math.ceil(scrollYScalar));
    requestAnimationFrame(() => scrollingTo(x, y, ++i));
  } else {
    window.scrollTo(x, y);
  }
}

export default scrollingTo;